import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Pf16Service } from 'src/app/services/pf16.service';

import { TestService } from 'src/app/services/test.service';

declare var $:any;

@Component({
  selector: 'app-create-pf16-factor',
  templateUrl: './create-pf16-factor.component.html',
  styleUrls: ['styles.css'
  ]
})
export class CreatePf16FactorComponent implements AfterViewInit {



  public pf16Form = this.fb.group({
    lowDesc: ['', Validators.required],
    highDesc: ['', Validators.required],
    name: [''],
  });



  constructor(private fb: FormBuilder, private pf16Service: Pf16Service, private testService:TestService) { 

    
  }

  ngOnInit(): void {
  

  }

  
  ngAfterViewInit():void{
    
  }

  ngOnDestroy(){



  }

  reset(){
    this.pf16Form.reset();
  }

  register(){

    if (this.pf16Form.get('name').value!=''){
      this.pf16Service.createFactor(this.pf16Form.value).subscribe(
        resp=>{
          this.pf16Form.reset();
        },
        err=>console.log(err)
      )

    }
  }





}
